<template>
  <div id="app-aside" >
    <div class="app-aside-control">
      <i :class="controlIcon" @click="toggleAside">{{ controlText }}</i>
    </div>
    <el-menu :default-active="currentIndex" :collapse="controlCollapse">
      <template v-for="(item, i) in sidebarItems">
        <span v-if="item.title" class="app-aside-title" :key="i">{{ item.text }}</span>
        <el-submenu v-if="item.trees && item.trees.length > 0" :index="item.index" :key="i">
          <template slot="title"><i :class="item.icon"></i><span>{{ item.text }}</span></template>
          <el-menu-item-group>
            <el-menu-item v-for="subitem in item.trees" :key="subitem.index" :index="subitem.index"
            :data-path="subitem.path" @click="goMain">{{ subitem.text }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item v-if="item.trees && item.trees.length <= 0" :data-path="item.path" :data-rb="item.role_btn" @click="goMain" :index="item.index" :key="i">
          <i :class="item.icon"></i><span>{{ item.text }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'app-aside',
  props: {
    sidebarItems:{
      type: Array
    }
  },
  watch: {
    sidebarItems(newVal, oldVal) {
      this.highlightSidebar()
      // 当loading值变化时执行的操作
    }
  },
  data () {
    return {
      controlIcon: 'el-icon-caret-left', // 右箭头 / 左箭头
      controlText: '收起', // 展开 / 收起
      controlCollapse: false, // 侧边栏展开状态
      currentIndex: '1' // 当前高亮 index
    }
  },
  methods: {
    /**
     * 通过路由检查当前高亮链接
     */
    highlightSidebar () {
      let that = this
      let currentLocation = window.location.href.split('#')[1]
      let highlightIndex = '1'
      for (let i = 0; i < that.sidebarItems.length; i++) {
        const lv1 = that.sidebarItems[i]
        if (lv1.path && lv1.path === currentLocation) highlightIndex = lv1.index
        if (lv1.trees) {
          for (let j = 0; j < lv1.trees.length; j++) {
            const lv2 = lv1.trees[j]
            if (lv2.path === currentLocation) highlightIndex = lv2.index
          }
        }
      }
      that.currentIndex = highlightIndex
      console.log(that.currentIndex)
    },
    /**
     * 跳转到 Main 中对应链接
     */
    goMain (e) {
      let that = this
      let linkPath = e.$el.dataset.path
      if (linkPath !== this.$route.path) {
        that.$router.replace({
          path: e.$el.dataset.path,
          query: {'role_business': e.$el.dataset.rb}
        })
      }else{
        that.$router.replace({path:'/load', query: {'role_business':e.$el.dataset.rb}})// 跳转页面 传参
        that.COOKIE.setCookie('path', e.$el.dataset.path, 7)
      }
      console.log(that.currentIndex)
    },
    /**
     * 收展侧边栏
     */
    toggleAside () {
      let that = this
      that.controlCollapse = !that.controlCollapse
      that.controlText = that.controlCollapse ? '' : '收起'
      that.controlIcon = that.controlCollapse ? 'el-icon-caret-right' : 'el-icon-caret-left'
      that.$emit('toggleAside', that.controlCollapse)
    }
  },
  mounted () {
    this.highlightSidebar()
  }
}
</script>

<style>
.el-menu {
  background-color: #f1f1f1;
}
.el-submenu__title,
.el-menu-item {
  font-size: 14px;
  height: 50px;
  line-height: 50px;
}
.el-submenu__title:hover,
.el-menu-item:focus, .el-menu-item:hover,
.el-menu-item:hover i,
.el-menu-item.is-active {
  color: #626c79;
  background-color: #fafafa;
}
.el-menu--collapse {
  width: 69px;
}
.app-aside-control > i {
  font-size: 13px;
  font-weight: bold;
  padding: 10px;
  color: #bebebe;
  cursor: pointer;
}
.app-aside-control > i:hover {
  color: #343A40;
}
.app-aside-title {
  padding-left: 10px;
  margin: 8px 0;
  display: block;
  color: #454545;
}
.el-table thead {
    color: #333333;
    font-weight: 500;
}
/* 大图预览的关闭图标 改为大一点的白色 */
.el-image-viewer__btn.el-image-viewer__close {
    color: #FFF;
    opacity: unset;
    top: 50px;
    right: 50px;
    width: 50px;
    height: 50px;
    font-size: 50px;
}
/* 角标DIV */
.published-div {
    position: relative;
    width: 100px;
    height: 100px;
    margin-left: 4px;
}
/* 角标 */
.published-search {
    position: relative;
    top: -33px;
    right: -75px;
}
/* 取消、确定 顺序调换*/
/* 设置取消按钮向右浮动，左magin为10px，即与确定按钮间距为10px */
.btn-custom-cancel {
  float: right;
  margin-left: 10px;
}
.el-link.el-link--primary :hover {
    color: #0684aa;
}
/* div可以滚动 */
.main-pdf {
  position: absolute;
  right: 0;
  top: 45px;
  bottom: 0;
  overflow-y: scroll;
}
/* 分割线 */
.el-divider--vertical {
  display: inline-block;
  /* weight: 1px; */
  height: 100%;
  margin: 0 8px;
  background: 0 0;
  border-left: 2px dashed #e8eaec;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/frame/Aside.vue